/* eslint-disable import/prefer-default-export */
import configFile from './global/configFile';

const envConfig = configFile(process.env.REACT_APP_ENV, process.env.INSTANCE);

const getLocation = function (href) {
  const l = document.createElement('a');
  l.href = href;
  return l;
};

let PATH_NAME = getLocation(envConfig.host).pathname;
PATH_NAME = PATH_NAME.length > 1 ? `${PATH_NAME}/` : PATH_NAME;

export const fsm = `${PATH_NAME}fsm`;
